// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S-EG","controls":"styles_controls__iXOjh","charLimit":"styles_charLimit__3pTM-","input":"styles_input__1S64h","send":"styles_send__7qMwN"};